// eslint-disable-next-line no-relative-import-paths/no-relative-import-paths
import PackageJson from "../../package.json"
import {type Environment} from "@environment/types"

/**
 * Configuration for preview deployments (i.e. all deployments to non-prod environments).
 */
export const environment: Environment = {
    production: true,
    name: "dev",
    version: PackageJson.version,

    auth: {
        google: {
            clientId: "608675176242-9a7778mmllu4026o5m3ehi2n58vir03n.apps.googleusercontent.com",
        },
        microsoft: {
            clientId: "151d8cd7-eff9-441e-b8b9-1072287949cb",
        },
    },

    firebase: {
        apiKey: "AIzaSyD4QYSCTEdEEkMUvqtCBb6_z_JxC1pZ20A",
        authDomain: "cm-platform-dev.firebaseapp.com",
        databaseURL: "https://cm-platform-dev.firebaseio.com",
        projectId: "cm-platform-dev",
        storageBucket: "cm-platform-dev.appspot.com",
        messagingSenderId: "608675176242",
        appId: "1:608675176242:web:a1164f2858a6f638e2412b",
    },
    firebaseConfig: {
        collectionEnabled: true,
    },

    rendering: {
        materialAssets: {
            fallbackTemplateId: 17484,
            samples: 64,
        },
        shaderBall: {
            templateId: 17482,
        },
        defaultQueueDomain: "colormass",
        maxConcurrentRenderJobs: 200,
    },

    storage: {
        bucketsPrefix: "cm-platform-dev-",
        usePostToUpload: false,
    },

    style: {
        application: {
            background: "#991b1b40",
        },
    },

    debug: {
        enableCallStack: false,
    },

    onboarding: {
        allowSkipPayment: false,
    },

    stripe: {
        fullyIntegrated: false,
    },

    configuratorUrl: "https://configurator-dev.colormass.com?apiVersion=2",
    platformDeployUrl: "https://dev.colormass.com",
    configuratorDeployUrl: "https://configurator-dev.colormass.com",
    gqlApiEndpoint: "https://gql-dev.colormass.com",
    jobsInstanceUrl: "https://jobs-dev.colormass.com",
    localTilingEndpoint: "ws://localhost:5678/",
}
